import * as yup from "yup";
import { db } from "~db/db";
import { postDeclaracao } from "~services/DuplaCategoriaService";

const trilhas = {
  TAC: "Auto Construção",
  IMO: "Imobiliária",
  IND: "Indústria",
  INFRA: "Infra Técnica",
};

const declaracaoSchema = yup.object({
  emailContato: yup.string().email("Email inválido").required("Email é obrigatório"),
  nomeContato: yup.string().required("Nome é obrigatório"),
  telContato: yup.string().required("Telefone é obrigatório"),
});

const useDeclaracao = () => {

  const enviarDeclaracao = async (clientInfo) => {
    try {
      const response = await postDeclaracao(clientInfo);

      return response;
    } catch (error) {
      throw error;
    }
  };

  const verificarDeclaracao = async (clienteId) => {
    const registro = await db.duplaCategoria.get(clienteId);
    return !!registro;
  };

  return {
    enviarDeclaracao,
    verificarDeclaracao,
    trilhas,
    declaracaoSchema,
  };
};

export default useDeclaracao;
